import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:Country');

export default class CountryService {
  constructor(gcs) {
    this.genericConfigService = gcs;
  }

  getCountries() {
    debug.info('getCountries');
    return this.genericConfigService.getConfig()
      .then(config => config.country_data);
  }

  getCountry(code) {
    debug.info('getCountry: %s', code);

    return this.getCountries()
      .then(countries => countries.find(c => c.value === code))
      .then(country => {
        if (country) {
          return country;
        }

        throw new Error('Country not found');
      });
  }

  getDefault() {
    return this.getCountries()
      .then(countries => {
        if (countries.length) {
          return countries[0];
        }

        throw new Error('No countries');
      });
  }
}

Injector.service('countryService', ['genericConfigService'], CountryService);



// WEBPACK FOOTER //
// ./src/services/CountryService.js